import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
  HttpClient
} from '@angular/common/http';
import { CurrencyPipe } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { MessageService, ConfirmationService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { DefaultStyles } from '@ai-document-processor/shared-libraries';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FronteggAppModule } from '@frontegg/angular';

import { routes } from './app.routes';
import { environment } from './environments/environment';
import { AuthInterceptor } from './http-interceptors/auth-interceptor';
import { WHATFIX_API_KEY } from './services/whatFix/whatfix.service';
import { TitleService } from './services/title/title.service';

// Angular CDK
import { DragDropModule } from '@angular/cdk/drag-drop';
import { A11yModule } from '@angular/cdk/a11y';

// Other
import { NgxDropzoneModule } from 'ngx-dropzone';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    { provide: WHATFIX_API_KEY, useValue: '4fd1ffb8-0d54-4848-b895-d1bded281fa6' },
    CurrencyPipe,
    Title,
    TitleService,
    MessageService,
    ConfirmationService,
    providePrimeNG({
      ripple: true,
      theme: {
        preset: DefaultStyles,
        options: {
          darkModeSelector: false
        }
      }
    }),
    importProvidersFrom(
      FormsModule,
      ReactiveFormsModule,
      DragDropModule,
      A11yModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient]
        }
      }),
      NgxDropzoneModule,
      FronteggAppModule.forRoot(environment.frontegg.moduleConfig)
    )
  ]
};
